require('./beneficiary.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');

// @commons
const { formatText } = require('core/i18n').i18n;
const {
    BENEFICIARY_TYPE_NEW,
    BENEFICIARY_TYPE_EXISTING,
    BENEFICIARY_TYPE_NGO,
    BENEFICIARY_TYPE_EXISTING_EDIT,
    CHARITYURL
} = require('constants/index');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;

// @components
const { BeneficiaryExisting } = require('./beneficiaryExisting/beneficiaryExisting');
const { BeneficiaryNew } = require('./beneficiaryNew/beneficiaryNew');
const BeneficiaryNGO = require('./beneficiaryNGO/beneficiaryNGO.jsx');

// @actions
const bankEntityActions = require('actions/bankEntity');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const { SOLIDARITY } = require('constants/flagBasedFeatures');

class Beneficiary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isCharity: false
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillMount() {
        const { actions: { handleBeneficiaryType }, charity, flagBasedFeatures } = this.props;
        if (charity === CHARITYURL && flagBasedFeatures.get('charity-cards-enabled')) {
            handleBeneficiaryType('NGO');
        }
    }

    componentDidMount() {
        const { charity } = this.props
        if (charity) {
            this.setState({
                isCharity: charity
            })
        }
    }

    buildCancelEditBeneficiarySection() {
        const { immBeneficiary, actions } = this.props;
        const isEditingBeneficiaryExisting = (immBeneficiary.get('type') === BENEFICIARY_TYPE_NEW) && immBeneficiary.getIn(['new', 'isEditingBeneficiaryExisting']);
        let content;

        if (isEditingBeneficiaryExisting)
            content = (
                <div className="transfer-beneficiary__header-editing clearfix">
                    <div className="transfer-beneficiary__profile-avatar-section pull-left">
                        <span className="icon-beneficiario transfer-beneficiary__profile-avatar-icon" />
                    </div>
                    <div className="transfer-beneficiary__cancel-edition-button pull-right">
                        <OKButton modifier="link-complementary" onClick={actions.handleCancelEditBeneficiary}>
                            <FormattedText value="transferSummary-step1CancelBeneficiaryEdition" />
                        </OKButton>
                    </div>
                </div>
            )

        return content;
    }

    buildRadioButtons(noBeneficiaries) {
        const { flagBasedFeatures, isEditingScheduled, immBeneficiary } = this.props;
        const isEditingBeneficiaryExisting = (immBeneficiary.get('type') === BENEFICIARY_TYPE_NEW) && immBeneficiary.getIn(['new', 'isEditingBeneficiaryExisting']);

        const options = [BENEFICIARY_TYPE_EXISTING, BENEFICIARY_TYPE_NEW];

        if (flagBasedFeatures.get('charity-cards-enabled') && flagBasedFeatures.get(SOLIDARITY)) {
            options.push(BENEFICIARY_TYPE_NGO);
        }

        return options.map((id, index) => {
            let label = formatText(`transferSummary-step1Beneficiary${id}`);
            let disabled = false;

            if (noBeneficiaries && id === BENEFICIARY_TYPE_EXISTING) {
                label = label.concat(` ${formatText('transferSummary-step1NoBeneficiaries')}`);
                disabled = true;
            }

            return (
                <RadioButton
                    key={index}
                    label={label}
                    value={id}
                    disabled={disabled || isEditingScheduled || isEditingBeneficiaryExisting}
                />
            );
        });
    }

    handleChangeBeneficiary = (value) => {
        const {
            actions,
            changeBeneficiary,
            charity,
            immBeneficiary,
            resetBankName,
        } = this.props;
        resetBankName();

        if (value !== BENEFICIARY_TYPE_NGO) {
            actions.setNotDeductibleNGOMessage(false);

            if (immBeneficiary.get('type') === BENEFICIARY_TYPE_NGO) {
                actions.setConcept('');
            }
        }

        if (charity === CHARITYURL && value === BENEFICIARY_TYPE_NGO) {
            this.setState({
                isCharity: true
            })
        } else if (charity !== CHARITYURL && value === BENEFICIARY_TYPE_NGO) {
            this.setState({
                isCharity: false
            })
        }
        changeBeneficiary(value);
        actions.handleBeneficiaryType(value);
    }

    getTypeBeneficiary() {
        const { immBeneficiary, charity } = this.props;
        let type = immBeneficiary.get('type');

        if (charity === CHARITYURL && !this.state.isCharity) {
            type = BENEFICIARY_TYPE_NGO;
            this.props.actions.handleBeneficiaryType(BENEFICIARY_TYPE_NGO);
        } else {
            const isEditingBeneficiaryExisting = (type === BENEFICIARY_TYPE_NEW) && immBeneficiary.getIn(['new', 'isEditingBeneficiaryExisting']);
            type = isEditingBeneficiaryExisting ? BENEFICIARY_TYPE_EXISTING : type;
        }

        return type;
    }

    render() {
        const {
            flagBasedFeatures,
            immBankEntity,
            immBeneficiaries,
            isEditingScheduled,
            isReusingTransfer,
            getBankNameFromIban,
            changeIbanBeneficiary,
            originCountry,
            getProductOffers,
            resetBankName
        } = this.props;
        let content;
        const cancelEditBeneficiarySection = this.buildCancelEditBeneficiarySection();

        if (immBeneficiaries.get('fetchSuccess')) {
            const { immBeneficiary, initialBeneficiaryId, actions, isNGOValid } = this.props;
            const noBeneficiaries = immBeneficiaries.get('byOrder').size === 0;
            const radioButtonsSection = this.buildRadioButtons(noBeneficiaries);
            let type = this.getTypeBeneficiary();
            let beneficiaryContent;

            const radioButtonGroupStyles = classnames('transfer-first-step__form-section', {
                'transfer-first-step__form-section--hidden': isReusingTransfer
            });

            type = immBeneficiary.getIn(['new', 'isEditingBeneficiaryExisting']) ? BENEFICIARY_TYPE_EXISTING_EDIT : type;

            if (type === BENEFICIARY_TYPE_EXISTING) {
                beneficiaryContent = (
                    <BeneficiaryExisting
                        immBankEntity={immBankEntity}
                        immBeneficiaryExisting={immBeneficiary.get('existing')}
                        initialBeneficiaryId={initialBeneficiaryId}
                        immBeneficiaries={immBeneficiaries}
                        actions={actions}
                        handleBeneficiary={changeIbanBeneficiary}
                    />
                );
            } else if (type === BENEFICIARY_TYPE_NGO && flagBasedFeatures.get('charity-cards-enabled')) {
                beneficiaryContent = (
                    <BeneficiaryNGO
                        immBeneficiaries={immBeneficiaries}
                        immBeneficiaryNew={immBeneficiary.get('new')}
                        getBankNameFromIban={getBankNameFromIban}
                        actions={actions}
                        isNGOValid={isNGOValid}
                        handleBeneficiary={changeIbanBeneficiary}
                        originCountry={originCountry}
                    />
                );
            } else if (type === BENEFICIARY_TYPE_EXISTING_EDIT || BENEFICIARY_TYPE_NEW) {
                beneficiaryContent = (
                    <BeneficiaryNew
                        immBankEntity={immBankEntity}
                        resetBankName={resetBankName}
                        immBeneficiaryNew={immBeneficiary.get('new')}
                        immBeneficiaries={immBeneficiaries}
                        actions={actions}
                        isEditingScheduled={isEditingScheduled}
                        isReusingTransfer={isReusingTransfer}
                        handleBeneficiary={changeIbanBeneficiary}
                        originCountry={originCountry}
                        getProductOffers={getProductOffers}
                    />
                );
            }

            content = (
                <div className="transfer-beneficiary">
                    <RadioButtonGroup
                        name="contact-type"
                        className={radioButtonGroupStyles}
                        idPrefix="contact-type-radio"
                        selectedValue={type}
                        onChange={this.handleChangeBeneficiary}
                    >
                        {radioButtonsSection}
                    </RadioButtonGroup>
                    {cancelEditBeneficiarySection}
                    {beneficiaryContent}
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

Beneficiary.propTypes = {
    actions: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
    immBankEntity: PropTypes.object,
    immBeneficiaries: PropTypes.object,
    immBeneficiary: PropTypes.object,
    initialBeneficiaryId: PropTypes.string,
    isEditingScheduled: PropTypes.bool,
    isNGOValid: PropTypes.bool,
    isReusingTransfer: PropTypes.bool,
    getBankNameFromIban: PropTypes.func.isRequired,
    charity: PropTypes.string.isRequired,
    changeIbanBeneficiary: PropTypes.bool.isRequired,
    changeBeneficiary: PropTypes.func.isRequired,
    originCountry: PropTypes.string,
    getProductOffers: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        isNGOValid: state.transfer.getIn(['steps', 0, 'isNGOValid']),
        originCountry: state.profile.get('originCountry'),
    }),
    {
        getBankNameFromIban: bankEntityActions.getBankNameFromIban,
        resetBankName: bankEntityActions.resetBankName
    }
)(withFeatureToggling(Beneficiary));
